module.exports = __webpack_public_path__ + "img/thumb_07.6ec034b0.jpg";